import type { AssessmentScoreLabel } from '@evaltick/shared';

/** Ant Design tag colour for each assessment score label. */
export const SCORE_LABEL_COLORS: Record<AssessmentScoreLabel, string> = {
  Strength: 'success',
  Developing: 'warning',
  'Needs Focus': 'error',
};
